<div class="leaders" *ngIf="filteredStatistic && selectedUser">
  <div class="user">
    <div class="photo">
      <a [routerLink]="getUserRoute(selectedUser.leaguePlayer.id)" [queryParams]="{season_id: seasonId, round: round}">
        <img [src]="selectedUser.leaguePlayer.photo.path" *ngIf="selectedUser.leaguePlayer.photo.path">
        <div class="empty-photo" *ngIf="!selectedUser.leaguePlayer.photo.path">{{ selectedUser.leaguePlayer.initials }}</div>
      </a>
      <img
        *ngIf="selectedUser.teamUser.team.logo.path"
        [src]="selectedUser.teamUser.team.logo.path"
        class="team-logo"
      >
      <div
        *ngIf="!selectedUser.teamUser.team.logo.path"
        [ngClass]="selectedUser.teamUser.team.getEmptyLogoClass()"
        class="team-logo"
      ></div>
    </div>
    <div class="full-name">
      <a
        mtgFitToParent
        [routerLink]="getUserRoute(selectedUser.leaguePlayer.id)"
        queryParamsHandling="preserve"
      >
        {{ selectedUser.leaguePlayer.shortName }}
      </a>
    </div>
    <div class="rating" *ngIf="selectedUser.leaguePlayer.rating">
      Индекс: {{ selectedUser.leaguePlayer.rating }}
    </div>

    <div class="stat">
      <div class="name">{{ param.title }}</div>
      <div class="value">{{ selectedUser[param.id] }}{{ param.percent ? '%' : '' }}</div>
    </div>
  </div>
  <div class="list">
    <a
      *ngFor="let item of filteredStatistic; let i = index"
      href="javascript:;"
      [ngClass]="{active: selectedUser.teamUser.id === item.teamUser.id}"
      (click)="selectedUser = item"
    >
      <span class="position">{{ i + 1 }}.</span>
      <span class="number">#{{ item.teamUser.number }}</span>
      <span class="full-name">
        {{ item.leaguePlayer.shortName }}
      </span>
      <span class="value">{{ item[param.id] }}</span>
    </a>
  </div>
</div>
